import { busService, HandshakeModuleMessage, ResponseHandshakeModuleMessage, SystemInitMessage } from "../bus";
const DEBUG_LOG_INITIALIZED_MODULES = false;
/*
 * A Module is a logically self-contained part of the application, communicating with other Modules with @see BusMessages.
 *
 * It can be bundled (maybe together with other Modules) in a Worker, but can also be part of the Main Thread.
 *
 * Subscribe to messages on the bus in the constructor.
 * Start sending messages in init();
 *
 * @deprecated Use `NewModule` instead!
 */
export default class Module {
    constructor(moduleId) {
        this.moduleId = moduleId;
        this.connection = busService.connection(moduleId);
        const handshakeModuleSubscription = this.connection.subscribeForAskRequest(HandshakeModuleMessage, (msg, askId) => {
            if (msg.moduleId !== this.moduleId)
                return;
            this.connection.answer(askId, new ResponseHandshakeModuleMessage(msg.moduleId));
            this.connection.unsubscribe(handshakeModuleSubscription);
        }, `:${this.moduleId}`);
        const systemInitSubscription = this.connection.subscribe(SystemInitMessage.typestatic, (e) => {
            if (SystemInitMessage.is(e)) {
                this.connection.onSystemInitReceived();
                if (DEBUG_LOG_INITIALIZED_MODULES)
                    console.info(`Initializing ${moduleId}`);
                this.init(e.locationHref);
                this.connection.unsubscribe(systemInitSubscription);
            }
            else {
                throw new Error(`unexpected event should match SystemInitMessage! {JSON.stringify(e)}`);
            }
        });
    }
    /**
     * Returns the module ID
     */
    getName() { return this.moduleId; }
}
